<template>
  <form @submit.prevent="login">
    <div class="p-input mb-3">
      <label for="email">{{ $t("loginpage.input.email") }}</label>
      <InputText
        id="email"
        v-model="form.email"
        class="col-12 mt-2"
        type="text"
        autocomplete="email"
      />
    </div>

    <div class="p-input mb-3">
      <label for="password">{{ $t("loginpage.input.password") }}</label>
      <InputText
        id="password"
        v-model="form.password"
        class="col-12 mt-2"
        type="password"
        autocomplete="password"
      />
    </div>

    <div class="p-input mb-5">
      <router-link to="/resetPassword">
        {{ $t("loginpage.input.resetpassword") }}
      </router-link>
    </div>

    <captcha-component
      ref="captcha"
      v-model:answer="form.captcha.answer"
      v-model:session="form.captcha.session"
    />

    <div>
      <p
        v-for="error in form.errors"
        :key="error"
        class="p-error"
      >
        {{ $t(error) }}
      </p>
    </div>
    <Button
      type="submit"
      class="p-button-rounded p-button-outlined"
      :disabled="loginButtonDisabled"
    >
      {{ $t("loginpage.input.login") }}
    </Button>
  </form>
</template>

<script>
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import CaptchaComponent from "@/components/CaptchaComponent.vue";

export default {
  name: "LoginForm",
  components: {CaptchaComponent, InputText, Button },
  data() {
    return {
      form: {
        email: "",
        password: "",
        captcha: {
          session: null,
          answer: null,
        },
        errors: "",
      },

    };
  },

  computed: {
    loginButtonDisabled() {
      return !this.form.email || !this.form.password || !this.form.captcha?.answer || !this.form.captcha?.session;
    },
  },

  methods: {
    async login() {
      const data = {
        email: this.form.email,
        password: this.form.password,
        sessionCode: this.form.captcha?.session,
        answer: this.form.captcha?.answer,
      };

      try {
        await this.$store.dispatch("auth/login", data)
      } catch (e) {
        this.form.captcha.answer = null;
        this.form.captcha.session = null;
        this.form.errors = e;
        this.$refs.captcha.reload();
      }
    },
  },
};
</script>

<style scoped>
button {
  float: right;
}
</style>
